module.exports = __webpack_public_path__ + "static/media/img_22.6bf28cad.JPG";